import { dom } from '@omegagrid/core';
import { msg } from '@omegagrid/localize';
import { FormContainer } from '@omegagrid/form';
import rp, { AppComponent, ParsedComponentId, Application, GridEditor, EditorContainer } from '@reporting/rp-app-host';
import { Chat, Sidebar } from './components';
import { ChatRenameFormAdapter, UsageGridAdapter } from './adapters'
import { UsageRange, USAGE_RANGES } from './types'

const createSidebar = (app: Application, componentId: ParsedComponentId) => dom.createElement<Sidebar>('rp-mf-ai-sidebar');

const createChat = (app: Application, componentId: ParsedComponentId) => dom.createElement<Chat>('rp-mf-ai-chat', {
	idChat: componentId.ids[1] ? parseInt(componentId.ids[1]) : null,
	readonly: componentId.ids[2] === 'readonly',
});

const createUsageGrid = async (app: Application, componentId: ParsedComponentId) => {
	const range = (componentId.ids[1] || '7d') as UsageRange;
	const component = dom.createElement<GridEditor>('rp-editor-grid');
	component.adapter = new UsageGridAdapter(range);
	component.noToolbar = true;
	return component;
}

const createUsageContainer = async (app: Application, componentId: ParsedComponentId) => {
	const container = dom.createElement<EditorContainer>('rp-editor-container', {
		items: [{
			id: 'range',
			width: 250,
			type: 'dropdown',
			value: '7d',
			caption: msg('Period'),
			items: USAGE_RANGES.map(r => ({ k: r.k, v: msg(r.v, { data: { v: r.k.replace(/\D/g, '') } }) })),
		}],
		createComponent: id => rp.host.createComponent(id),
		// toolbar selection -> inner grid component id
		updateComponentId: (values) => {
			const range = values['range'] || '7d';
			return `ai-usage-${range}`;
		}
	});

	return container;
}

const createRenameForm = (app: Application, componentId: ParsedComponentId) => {
	const component = dom.createElement<FormContainer>('og-form-container');
	component.adapter = new ChatRenameFormAdapter();
	return component as unknown as AppComponent;
}

export const componentFactories = new Map<string, (app: Application, componentId: ParsedComponentId) => AppComponent|Promise<AppComponent>>([
	['ai', createSidebar],
	['chat', createChat],
	['usage', createUsageGrid],
	['usageContainer', createUsageContainer],
	['renameForm', createRenameForm],
]);
